import { c as _c } from "react/compiler-runtime";
import type { ChatModelOption, ChatModelProvider } from '@/lib/ai/chat-models';
import { ChevronDown } from 'lucide-react';
import { ModelSelector, ModelSelectorContent, ModelSelectorDialog, ModelSelectorEmpty, ModelSelectorGroup, ModelSelectorInput, ModelSelectorItem, ModelSelectorList, ModelSelectorName, ModelSelectorSelectedIcon, ModelSelectorTrigger } from '@/components/ai-elements/model-selector';
import { Button } from '@/components/ui/button';
import { BetterTooltip } from '@/components/ui/tooltip';
type ChatModelGroup = {
  provider: ChatModelProvider;
  models: ChatModelOption[];
};
type ChatModelSelectorProps = {
  canSelectChatModel: boolean;
  isLoading: boolean;
  isModelSelectorOpen: boolean;
  modelsByProvider: ChatModelGroup[];
  selectedModel: string;
  selectedModelInfo: ChatModelOption;
  setIsModelSelectorOpen: (open: boolean) => void;
  setSelectedModel: (model: string) => void;
};
export function ChatModelSelector(t0) {
  const $ = _c(27);
  const {
    canSelectChatModel,
    isLoading,
    isModelSelectorOpen,
    modelsByProvider,
    selectedModel,
    selectedModelInfo,
    setIsModelSelectorOpen,
    setSelectedModel
  } = t0;
  if (!canSelectChatModel) {
    return null;
  }
  let t1;
  if ($[0] !== selectedModelInfo.label) {
    t1 = <span className="max-w-[140px] truncate">{selectedModelInfo.label}</span>;
    $[0] = selectedModelInfo.label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronDown className="h-3 w-3 opacity-50" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLoading || $[4] !== t1) {
    t3 = <BetterTooltip content="Select model" side="top"><ModelSelectorTrigger asChild={true}><Button className="h-6 gap-1 rounded-md px-2 text-xs font-normal text-muted-foreground hover:bg-primary/10 hover:text-foreground transition-all duration-200" variant="ghost" disabled={isLoading} type="button">{t1}{t2}</Button></ModelSelectorTrigger></BetterTooltip>;
    $[3] = isLoading;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ModelSelectorInput placeholder="Search models..." className="h-9" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ModelSelectorEmpty>No models found.</ModelSelectorEmpty>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== modelsByProvider || $[9] !== selectedModel || $[10] !== setIsModelSelectorOpen || $[11] !== setSelectedModel) {
    let t7;
    if ($[13] !== selectedModel || $[14] !== setIsModelSelectorOpen || $[15] !== setSelectedModel) {
      t7 = t8 => {
        const {
          provider,
          models
        } = t8;
        return <ModelSelectorGroup key={provider} heading={provider}>{models.map(model => <ModelSelectorItem key={model.value} value={model.value} keywords={[model.label, ...model.keywords]} onSelect={() => {
            setSelectedModel(model.value);
            setIsModelSelectorOpen(false);
          }}><ModelSelectorName>{model.label}</ModelSelectorName>{selectedModel === model.value && <ModelSelectorSelectedIcon />}</ModelSelectorItem>)}</ModelSelectorGroup>;
      };
      $[13] = selectedModel;
      $[14] = setIsModelSelectorOpen;
      $[15] = setSelectedModel;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = modelsByProvider.map(t7);
    $[8] = modelsByProvider;
    $[9] = selectedModel;
    $[10] = setIsModelSelectorOpen;
    $[11] = setSelectedModel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <ModelSelectorList>{t5}{t6}</ModelSelectorList>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== selectedModel || $[20] !== t7) {
    t8 = <ModelSelectorContent className="max-w-[260px] p-0"><ModelSelectorDialog defaultValue={selectedModel}>{t4}{t7}</ModelSelectorDialog></ModelSelectorContent>;
    $[19] = selectedModel;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== isModelSelectorOpen || $[23] !== setIsModelSelectorOpen || $[24] !== t3 || $[25] !== t8) {
    t9 = <ModelSelector open={isModelSelectorOpen} onOpenChange={setIsModelSelectorOpen}>{t3}{t8}</ModelSelector>;
    $[22] = isModelSelectorOpen;
    $[23] = setIsModelSelectorOpen;
    $[24] = t3;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}